import { useSearchParams } from "react-router-dom";

export const useURLParamsSpreadsheets = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const get = (name: string) => {
    return searchParams.get(name) ?? "";
  };
  const set = (name: string, value: any) => {
    searchParams.set(name, value);
    setSearchParams(searchParams.toString());
  };
  const rm = (name) => {
    searchParams.delete(name);
    setSearchParams(searchParams.toString());
  };

  return {
    page: {
      get: () => {
        const pg = parseInt(get("page"));
        if (isNaN(pg) || pg < 1) return 1;
        return pg;
      },
      set: (page: string) => set("page", page),
      rm: () => rm("page"),
    },
    bin: {
      get: () => get("bin"),
      set: (bin: string) => set("bin", bin),
      rm: () => rm("bin"),
    },
    compensationType: {
      get: () => get("compensationType"),
      set: (compensationType: string) =>
        set("compensationType", compensationType),
      rm: () => rm("compensationType"),
    },
    signedAtFrom: {
      get: () => get("signedAtFrom"),
      set: (signedAtFrom: string) => set("signedAtFrom", signedAtFrom),
      rm: () => rm("signedAtFrom"),
    },
    signedAtUntil: {
      get: () => get("signedAtUntil"),
      set: (signedAtUntil: string) => set("signedAtUntil", signedAtUntil),
      rm: () => rm("signedAtUntil"),
    },
    companyName: {
      get: () => get("companyName"),
      set: (companyName: string) => set("companyName", companyName),
      rm: () => rm("companyName"),
    },
    applicationNo: {
      get: () => get("applicationNo"),
      set: (applicationNo: string) => set("applicationNo", applicationNo),
      rm: () => rm("applicationNo"),
    },
    assignmentType: {
      get: () => get("assignmentType"),
      set: (assignmentType: string) => set("assignmentType", assignmentType),
      rm: () => rm("assignmentType"),
    },
    assigneeId: {
      get: () => get("assigneeId"),
      set: (assigneeId: string) => set("assigneeId", assigneeId),
      rm: () => rm("assigneeId"),
    },
    applicationYear: {
      get: () => get("applicationYear"),
      set: (applicationYear: string) => set("applicationYear", applicationYear),
      rm: () => rm("applicationYear"),
    },
  }
}
